module.exports = __webpack_public_path__ + "static/media/claimsform.84d64706.jpeg";